import { motion, AnimatePresence } from "framer-motion";

const LoadingOverlay = ({
  visible = false,
  message = "Loading...",
  subtext = "Please wait while we process your data.",
  icon: Icon,
}) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="loading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/80 backdrop-blur-md"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex flex-col items-center gap-4"
          >
            <div className="relative">
              <div className="w-24 h-24 rounded-full border-4 border-blue-500/40 animate-pulse" />
              <div className="absolute inset-0 flex items-center justify-center">
                {Icon ? (
                  <Icon className="text-primary text-5xl animate-bounce" />
                ) : (
                  <div className="w-6 h-6 bg-primary rounded-full animate-ping" />
                )}
              </div>
              <div className="absolute -inset-3 rounded-full border border-blue-400/30 blur-md animate-ping" />
            </div>

            <h2 className="text-2xl font-bold text-blue-400">{message}</h2>

            <motion.div
              initial={{ width: 0 }}
              animate={{ width: "80%" }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "reverse",
              }}
              className="h-1 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 rounded-full"
            />

            <p className="text-gray-400 text-sm mt-2">{subtext}</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingOverlay;
